import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { set } from "react-hook-form";
import { IAuftrag } from "../types/Types";


/**
 * @author noone
 */

export type ParameterState = {
    linkuid: string | null,
    listAuftragWithStatus: string,
    googleToken: string | null,
    selectedAuftragIds: IAuftrag[],
}

const initialState = {
    linkuid: null,
    listAuftragWithStatus: "IN_TERMINIERUNG",
    googleToken: null,
    selectedAuftragIds: [],
} as ParameterState;

const allParameterSlice = createSlice({
    name: 'allParameter',
    initialState: initialState,
    reducers: {
        setLinkuid(state, action: PayloadAction<string>) {
            state.linkuid = action.payload;
        },
        setListAuftragWithStatus(state, action: PayloadAction<string>) {
            state.listAuftragWithStatus = action.payload;
        },
        setGoogleToken(state, action: PayloadAction<string>) {
            state.googleToken = action.payload;
        },
        setSelectedAuftragIds(state, action: PayloadAction<IAuftrag[]>) {
            state.selectedAuftragIds = action.payload;
        },
        toggleSelectedAuftragIds(state, action: PayloadAction<IAuftrag>) {
            const auftrag = action.payload;
            if (state.selectedAuftragIds.filter((i) => i.uid === auftrag.uid).length > 0) {
                state.selectedAuftragIds = state.selectedAuftragIds.filter((i) => i.uid !== auftrag.uid);
            } else {
                state.selectedAuftragIds.push(auftrag);
            }
        },
    }
});

export const {

    setLinkuid,
    setListAuftragWithStatus,
    setGoogleToken,
    setSelectedAuftragIds,
    toggleSelectedAuftragIds,

} = allParameterSlice.actions;

export default allParameterSlice;


